/**
 * SmartClaw + Dawn: smooth #anchors; optional shadow for .sc-navbar (if you add SmartClaw header later)
 */
(function () {
  document.documentElement.classList.remove('no-js');

  function smoothScrollAnchors(root) {
    root.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
      var id = anchor.getAttribute('href');
      if (!id || id === '#') return;
      anchor.addEventListener('click', function (e) {
        var target = document.querySelector(id);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  smoothScrollAnchors(document);

  var navbars = document.querySelectorAll('.sc-navbar');
  if (navbars.length) {
    function onScroll() {
      var y = window.pageYOffset || document.documentElement.scrollTop;
      navbars.forEach(function (nav) {
        nav.style.boxShadow = y > 50 ? '0 2px 20px rgba(0,0,0,0.08)' : 'none';
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
})();
